<template>

  <div class="jumbotron">
    <div style="max-width: 820px;">
      <h1 class="display-4" style="font-size: 2.8rem;"><i class="fa-solid fa-lock"></i> {{ title }}</h1>
      <p class="lead">Este recurso não está habilitado para o plano atual.</p>
      <hr class="my-4">
      <h5>Como desbloquear este recurso?</h5>
      <p>Para obter mais informações sobre como habilitar esse e outros recursos, entre em contato com nosso suporte.</p>
      <a class="btn btn-primary btn-lg mt-3" href="#" role="button">Fale agora conosco</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Unavailable',
  components: {
  },
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  metaInfo () {
    return {
      title: this.$t('Requisitions')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Unavailable/Unavailable.vue